import React from "react";
import {LayoutAuthWithForm} from "../../../layouts";
import {AuthInput, AuthPwdInput} from "../../../helpers/InputsHelpers";
import {Box} from "@material-ui/core";
import trim from "mn-utils/trim";
import {object, string} from "yup";
import toLower from "mn-utils/toLower";
import {Link, replaceLocation} from "../../../../router";
import {
  LINK_RECOVERY_TOKEN,
  LINK_SIGN_IN
} from "../../../../constants/links";
import {apiAuthRecoveryToken, decorateReconnect} from "../../../../api/_auth";

export default () => {
  const initialEmail = localStorage.getItem('email');
  const data = {email: initialEmail || ''};

  const schema = object({
    email: string().isValidEmail().required()
  });

  const forgotPassword = decorateReconnect(apiAuthRecoveryToken);

  const onSubmit = (data) => (
    forgotPassword(data)
  );
  const onResult = () => {
    replaceLocation({
      path: LINK_RECOVERY_TOKEN,
    })
  };

  const resultModalData = ['Check your email!', 'We have sent your recovery token.'];

  return (
    <LayoutAuthWithForm
      title="Recovery password"
      description="We will send recovery token to the specified email"
      formProps={{
        schema,
        data,
        changesCheckDisabled: !!initialEmail,
        onSubmit,
        onResult,
        resultModalData
      }}
      content={(formCtx) => (
        <AuthInput
          name="email"
          formCtx={formCtx}
          onChangeHandlers={[
            trim,
            toLower,
            (val) => {
              localStorage.setItem('email', val)
              return val;
            }
          ]}
        />
      )}
      beforeFooter={(
        <Link
          href={LINK_SIGN_IN}
          className="c5B47FF olN tdU dn f12 fw3 o70:h"
        >I have a password</Link>
      )}
      submitBtnText="Send recovery token"
    />
  )
}
